<div class="form-group">
  <label for="ngControl.control">{{label}}</label>
  <input
    [class.is-invalid]="ngControl.touched && ngControl.invalid"
    type="{{type}}"
    class="form-control"
    [formControl]="ngControl.control"
    placeholder={{label}}>
    @if (ngControl.control.errors?.required) {
      <div class="invalid-feedback">Please enter a {{label}}!</div>
    }
    @if (ngControl.control.errors?.minlength) {
      <div class="invalid-feedback">{{label}} must be at least {{ngControl.control.errors.minlength['requiredLength']}}!</div>
    }
    @if (ngControl.control.errors?.maxlength) {
      <div class="invalid-feedback">{{label}} must be at most {{ngControl.control.errors.maxlength['requiredLength']}}!</div>
    }
    @if (ngControl.control.errors?.isMatching) {
      <div class="invalid-feedback">Passwords do not match!</div>
    }
  </div>